import styled from 'styled-components';

export const JobList = styled.div`
  display: grid;
  gap: 24px;
  grid-template-columns: repeat(auto-fill, minmax(390px, 1fr));
`;
